export const environment = {
  apiUrl: 'https://ext-api-admin-staging.dialogcrm.cloud',
  keycloakUrl: 'https://sso-staging.dialogcrm.cloud',
  keycloakRealm: 'EKS',
  keycloakClientId: 'external-services-web',
};
